import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

/**
 * Pill / Badge — handoff COMPONENTS §13
 * Mono 11px, weight 600, padding 4×11, radius pill
 * .dot opcional currentColor
 */
const pillVariants = cva(
  'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-pill border font-mono text-[11px] font-semibold uppercase tracking-wider',
  {
    variants: {
      tone: {
        default: 'bg-card-soft text-fg-muted border-card-stroke',
        mint: 'bg-mint-soft text-mint-deep border-transparent',
        ink: 'bg-ink text-on-ink border-transparent',
        lilac: 'bg-lilac-soft text-lilac-deep border-transparent',
        pass: 'bg-pass-soft text-pass border-transparent',
        warn: 'bg-warn-soft text-warn border-transparent',
        block: 'bg-block-soft text-block border-transparent',
        info: 'bg-info-soft text-info border-transparent',
      },
    },
    defaultVariants: { tone: 'default' },
  },
);

export interface PillProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof pillVariants> {
  dot?: boolean;
}

export function Pill({ className, tone, dot, children, ...props }: PillProps) {
  return (
    <span className={cn(pillVariants({ tone }), className)} {...props}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}
